import {Component, EventEmitter, forwardRef, Input, OnInit, Output, signal, ViewEncapsulation} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';
import {AutoUnsubscribe} from '../../../decorators/auto-unsubscribe.decorator';
import {SUBSCRIPTIONS} from 'src/app/common/utils/constants';

@Component({
  selector: 'mc-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SearchInputComponent),
    },
  ],
})
@AutoUnsubscribe()
export class SearchInputComponent implements OnInit, ControlValueAccessor {
  @Input() placeholder: string;
  @Output() focusEvent = new EventEmitter<Event>();
  @Output() blurEvent = new EventEmitter<FocusEvent>();
  @Output() changeValue = new EventEmitter<string>();
  searchValue: FormControl = new FormControl();
  showIcon: boolean = true;
  showClearIcon = signal(false);

  getSiteName(url: string) {
    if (!url) {
      return '';
    }
    // Remove http://, https://, // if needed
    let siteName = url.replace(/(^\w+:|^)\/\//, '');
    // Remove www. if needed
    siteName = siteName.replace(/www./, '');
    // Remove right part of the website (lipton.com/test1/test2/test3 => lipton.com)
    siteName = siteName.split('/')[0];
    return siteName;
  }

  initNameChangeSubscription(onChange?: any) {
    this[SUBSCRIPTIONS].add(
      this.searchValue.valueChanges
        .pipe(debounceTime(400), distinctUntilChanged(), map(this.getSiteName))
        .subscribe(value => {
          this.showClearIcon.set(!!value);
          this.onChange(value);
          this.onTouched();
          this.changeValue.emit(value);
        }),
    );
  }

  ngOnInit(): void {
    this.initNameChangeSubscription();
  }

  onTouched = () => {};
  public registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }

  onChange = (value: any) => {};
  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  writeValue(value: any) {
    this.searchValue.setValue(value);
  }

  focusHandler(event: Event): void {
    this.onTouched();
    this.showIcon = false;
    this.focusEvent.emit(event);
  }

  blurHandler(event: FocusEvent): void {
    this.onTouched();
    this.showIcon = true;
    this.blurEvent.emit(event);
  }

  keydown(event: Event): void {
    event.stopPropagation();
  }

  clearInput() {
    this.searchValue.setValue(null);
  }
}
